import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApresentacaoService } from './apresentacao.service';

@Component({
  selector: 'app-apresentacao',
  templateUrl: './apresentacao.component.html',
  styleUrls: ['./apresentacao.component.scss'],
})
export class ApresentacaoComponent implements OnInit {
  catalogo: any;
  apresentacao: string;
  catalogoSelecionado: any;
  catalogos: any;
  baseUrlCatalogo: any;
  totalCursos: any;
  ultimaEdicao: any;

  constructor(
    private route: ActivatedRoute,
    private apresentacaoService: ApresentacaoService
  ) { }

  ngOnInit(): void {
    this.catalogo = this.route.snapshot.data.apresentacao;
    this.apresentacao = this.catalogo.apresentacao;
    this.catalogos = [
      ...this.apresentacaoService.getLinhaTempo(),
      {
        id: +this.catalogo.edicao,
        edicao: this.catalogo.edicao,
        ano: this.catalogo.ano,
        evolucao: `${this.catalogo.quantidadeCursos} cursos, nova forma de apresentação, eletrônica e interativa`,
        data: '2022',
        url: '/cursos',
      },
    ];

    this.ultimaEdicao = this.catalogos.length; // Último botão ativo por padrão

    this.catalogoSelecionado = this.catalogos.find((catalogo: any) => {
      return catalogo.id === this.ultimaEdicao;
    });

    this.baseUrlCatalogo = 'assets/documents/catalogos_anteriores/';
  }

  selecionaEdicao(id: number) {
    if (id) {
      this.catalogoSelecionado = this.catalogos.find((catalogo: any) => {
        return catalogo.id === id;
      });
    }
  }

  irParaAnterior() {
    if (this.catalogoSelecionado.id > 1) {
      this.catalogoSelecionado = this.catalogos.find((catalogo: any) => {
        return catalogo.id === this.catalogoSelecionado.id - 1;
      });
    }
  }

  irParaProximo() {
    if (this.catalogoSelecionado.id < this.ultimaEdicao) {
      this.catalogoSelecionado = this.catalogos.find((catalogo: any) => {
        return catalogo.id === this.catalogoSelecionado.id + 1;
      });
    }
  }
}
